import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import { ProbeEditorView } from "@/components/probe/probeEditor";

const ProbeList: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_probe">
      <ProbeEditorView />
    </RestrictedPage>
  );
};

export default ProbeList;
